// removed by extract-text-webpack-plugin
module.exports = {"main":"_1OsKSZM24A278insGPYjxf"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Manager/Manager.scss
// module id = 969
// module chunks = 0